import type { IconProps } from './types';

function ShoppingCartIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M17.5 1H23V6.5M6.5 1H1V6.5M17.5 23H23V17.5M6.5 23H1V17.5M5.3625 6.05005H7.22142V15.5434H15.5772L18.3625 8.52983H9.99614M7.22142 19.0501V18.5238H7.74396V19.0501H7.22142ZM11.3993 19.0501V18.5238H11.9218V19.0501H11.3993Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { ShoppingCartIcon };
